//
// Add 'toISODateString' function to all JavaScript builtin date instances
// This function truncates the time and sends only the date, putting it in a format that can be received by aspnet.
//
Date.prototype.toISODateString = function () {
    return this.toISOString().split('T')[0];
};